import moment from "moment";
import Constants from "../models/utility/Constants";
import { ICountdownTimer } from "../models/utility/ICountdownTimer";

export default class TimerProvider {
    public static RemainingTime(date: string, offset: number): ICountdownTimer {
        const now = moment(Constants.CurrentDate())
            .add(offset, "milliseconds")
            .local();

        const m = moment(date).local();
        const duration = moment.duration(m.diff(now));

        const days = Math.floor(duration.asDays());
        duration.subtract(moment.duration(days, "days"));
        if (days < 0) {
            return {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            };
        }

        const hours = Math.floor(duration.asHours());
        duration.subtract(moment.duration(hours, "hours"));
        if (hours < 0) {
            return {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            };
        }

        const minutes = Math.floor(duration.asMinutes());
        duration.subtract(moment.duration(minutes, "minutes"));
        if (minutes < 0) {
            return {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            };
        }

        const seconds = Math.floor(duration.asSeconds());
        if (seconds < 0) {
            return {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            };
        }

        return {
            days,
            hours,
            minutes,
            seconds
        };
    }
}
